/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_X_Move_RightInputs */

const en_input_position_x_move_right = /** @type {(inputs: Input_Position_X_Move_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move Right 1 Character`)
};

const fr_input_position_x_move_right = /** @type {(inputs: Input_Position_X_Move_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déplacer à Droite de 1 Caractère`)
};

const de_input_position_x_move_right = /** @type {(inputs: Input_Position_X_Move_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewege dich um 1 Zeichen nach rechts`)
};

const it_input_position_x_move_right = /** @type {(inputs: Input_Position_X_Move_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sposta a destra 1 carattere`)
};

const ru_input_position_x_move_right = /** @type {(inputs: Input_Position_X_Move_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переместить вправо на 1 символ`)
};

const es_input_position_x_move_right = /** @type {(inputs: Input_Position_X_Move_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mover 1 carácter a la derecha`)
};

const zh_cn2_input_position_x_move_right = /** @type {(inputs: Input_Position_X_Move_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`向右移动 1 个字符`)
};

const ja_input_position_x_move_right = /** @type {(inputs: Input_Position_X_Move_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1文字右に移動`)
};

const hi_input_position_x_move_right = /** @type {(inputs: Input_Position_X_Move_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दाईं ओर 1 अक्षर आगे बढ़ें`)
};

const pt_pt2_input_position_x_move_right = /** @type {(inputs: Input_Position_X_Move_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mova 1 caractere para a direita`)
};

/**
* | output |
* | --- |
* | "Move Right 1 Character" |
*
* @param {Input_Position_X_Move_RightInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_x_move_right = /** @type {((inputs?: Input_Position_X_Move_RightInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_X_Move_RightInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_input_position_x_move_right(inputs)
	if (locale === "de") return de_input_position_x_move_right(inputs)
	if (locale === "it") return it_input_position_x_move_right(inputs)
	if (locale === "ru") return ru_input_position_x_move_right(inputs)
	if (locale === "es") return es_input_position_x_move_right(inputs)
	if (locale === "zh-CN") return zh_cn2_input_position_x_move_right(inputs)
	if (locale === "ja") return ja_input_position_x_move_right(inputs)
	if (locale === "hi") return hi_input_position_x_move_right(inputs)
	if (locale === "pt-PT") return pt_pt2_input_position_x_move_right(inputs)
	return en_input_position_x_move_right(inputs)
});